import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import useReveal from "../hooks/useReveal";
import { useT } from "../i18n/LanguageContext";
import WaitlistForm from "../components/WaitlistForm";

export default function Resources() {
  const t = useT();
  const root = useReveal();
  const categories = t("resources.categories");

  return (
    <div ref={root} className="pt-32 md:pt-40">
      <section className="container-x py-20 md:py-28">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 items-end">
          <div className="md:col-span-8">
            <p className="reveal eyebrow">{t("resources.eyebrow")}</p>
            <h1 className="reveal reveal-delay-1 mt-8 font-serif text-5xl md:text-7xl tracking-tight text-[#1A1A1A] leading-[0.95]">
              {t("resources.title")}
            </h1>
          </div>
          <div className="md:col-span-4 md:pb-3">
            <p className="reveal reveal-delay-2 text-lg text-[#4A4A4A] leading-relaxed">
              {t("resources.intro")}
            </p>
          </div>
        </div>
      </section>

      <section className="bg-[#F3F1EA] border-y border-[rgba(26,26,26,0.06)] py-24 md:py-32">
        <div className="container-x">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-[rgba(26,26,26,0.06)] border border-[rgba(26,26,26,0.06)]">
            {categories.map((c, i) => {
              const isInstitution = c.tag === "For Institutions" || c.tag === "Para Instituciones";
              const to = isInstitution ? "/contact" : "#";
              const inner = (
                <div className="p-8 md:p-12 bg-[#F8F7F2] hover:bg-[#FFFFFF] transition-colors h-full group">
                  <p className="text-[0.65rem] uppercase tracking-[0.32em] text-[#9A7E47]">
                    {c.tag}
                  </p>
                  <h2 className="mt-6 font-serif text-3xl md:text-4xl text-[#1A1A1A] tracking-tight leading-[1.05]">
                    {c.title}
                  </h2>
                  <p className="mt-6 text-[#4A4A4A] leading-relaxed max-w-lg">
                    {c.body}
                  </p>
                  <p className="mt-8 inline-flex items-center gap-2 text-[0.7rem] uppercase tracking-[0.22em] text-[#9A7E47] font-medium group-hover:gap-3 transition-all">
                    {c.link} <ArrowRight size={12} />
                  </p>
                </div>
              );
              return isInstitution ? (
                <Link
                  key={i}
                  to={to}
                  className={`reveal reveal-delay-${(i % 4) + 1}`}
                  data-testid={`resource-card-${i + 1}`}
                >
                  {inner}
                </Link>
              ) : (
                <div
                  key={i}
                  className={`reveal reveal-delay-${(i % 4) + 1}`}
                  data-testid={`resource-card-${i + 1}`}
                >
                  {inner}
                </div>
              );
            })}
          </div>
        </div>
      </section>

      <section className="container-x py-32 md:py-40">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16 items-start">
          <div className="lg:col-span-5">
            <p className="reveal eyebrow">Stay informed</p>
            <h3 className="reveal reveal-delay-1 mt-6 font-serif text-4xl md:text-5xl tracking-tight text-[#1A1A1A] leading-[1.02]">
              {t("resources.cta")}
            </h3>
          </div>
          <div className="lg:col-span-7">
            <div className="reveal">
              <WaitlistForm
                interest="resources"
                testIdPrefix="resources-waitlist"
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
